import { Formik } from "formik";
import { memo, useContext, useEffect } from "react";
import * as yup from "yup";

import { AppContext } from "app/appContext";
import { Row } from "react-bootstrap";

import {
  checkIfAlreadyLoggedIn,
  otpVerifyForLogin,
  signIn,
} from "app/services/AuthService";
import { encryptMessage } from "app/services/CommonService";
import config from "config.json";
import { Helmet } from "react-helmet";
import LaddaButton, { EXPAND_LEFT } from "react-ladda";
import { useNavigate } from "react-router-dom";

const { companyName } = config;

const Login = () => {
  const SignInSchema = yup.object().shape({
    username: yup.string().required("Username is required"),
    password: yup.string().required("Password is required"),
    otp: yup.string().when([], {
      is: () => context?.isLoggedInOtp === true,
      then: yup
        .string()
        .required("OTP is required")
        .length(6, "OTP must be exactly 6 digits")
        .matches(/^\d{6}$/, "OTP must be exactly 6 digits"),
      otherwise: yup.string().notRequired(),
    }),
  });

  const InitialValue = {
    username: "",
    password: "",
    otp: "",
  };

  const navigate = useNavigate();
  const context = useContext(AppContext);

  useEffect(() => {
    checkIfAlreadyLoggedIn(navigate, context);
  }, []);

  const handleSubmitSignIn = async (values) => {
    await signIn(values, context);
  };
  const handleSubmitVerify = async (values) => {
    const request = {
      otPkey: encryptMessage(`userName=${values.username}|otp=${values.otp}`),
    };

    await otpVerifyForLogin(request, navigate, context);
  };

  return (
    <>
      <Helmet>
        <title>Sign In</title>
      </Helmet>
      <div
        className="auth-layout-wrap"
        style={{
          background: "#4568DC",
          background: "linear-gradient(to right, #B06AB3, #4568DC)",
        }}
      >
        <div className="auth-content">
          <div className="card o-hidden">
            <div className="row justify-content-md-center">
              <div className="ofset-md-5 col-md-7">
                <div className="p-4">
                  <div className="auth-logo text-center mb-4">
                    <img
                      src={`/assets/images/logo/${companyName}.gif`}
                      alt=""
                      style={{ width: "82px", height: "80px" }}
                    />
                  </div>
                  <h1
                    className="mb-3 text-20 text-center"
                    style={{ marginLeft: "-9%" }}
                  >
                    Sign In
                  </h1>

                  <Formik
                    initialValues={InitialValue}
                    validationSchema={SignInSchema}
                    onSubmit={
                      !context.isLoggedInOtp
                        ? handleSubmitSignIn
                        : handleSubmitVerify
                    }
                  >
                    {({
                      values,
                      errors,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label htmlFor="email">User Name</label>
                          <input
                            className="form-control form-control position-relative"
                            type="username"
                            name="username"
                            placeholder="Enter Username"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.username}
                          />
                          {errors.username && (
                            <div className="text-danger mt-1 ml-2">
                              {errors.username}
                            </div>
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="password">Password</label>
                          <input
                            className="form-control form-control"
                            type="password"
                            name="password"
                            placeholder="Enter Password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                          />
                          {errors.password && (
                            <div className="text-danger mt-1 ml-2">
                              {errors.password}
                            </div>
                          )}
                        </div>
                        {context.isLoggedInOtp && (
                          <div className="form-group">
                            <label htmlFor="otp">OTP</label>
                            <input
                              className="form-control form-control"
                              type="otp"
                              name="otp"
                              placeholder="Enter OTP"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.otp}
                            />
                            {errors.otp && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.otp}
                              </div>
                            )}
                          </div>
                        )}
                        <Row className="mt-4">
                          <LaddaButton
                            className={`btn btn-primary  m-auto`}
                            type="submit"
                            loading={context.isLoadingLogin}
                            progress={0.5}
                            data-spinner-size={20}
                            data-style={EXPAND_LEFT}
                          >
                            {context.isLoadingLogin
                              ? "Authenticating..."
                              : context.isLoggedInOtp
                              ? "Continue"
                              : "Sign In"}
                          </LaddaButton>
                        </Row>
                      </form>
                    )}
                  </Formik>

                  <div className="mt-3 text-center">
                    {/* <Link to="/session/forgot-password" className="text-muted">
      <u>Forgot Password?</u>
    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(Login);
